<template>
  <div>
    <PageHeader title="Buy Credits"></PageHeader>
    <v-container class="page-bottom pa-0">
      <v-row>
        <v-col>
          <v-card
            outlined
          >
            <v-container>
              <v-row>
                <v-col>
                  <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    @submit.prevent="validate"
                  >
                    <v-radio-group 
                      v-model="credits"
                      :rules="[rules.required]"
                    >
                      <v-radio
                        v-for="creditOption in creditOptions"
                        :key="creditOption.id"
                        :label="`${creditOption.credits} credits (£${creditOption.value})`"
                        :value="creditOption.value"
                      ></v-radio>
                    </v-radio-group>

                    <v-btn
                      block
                      outlined
                      large
                      style="color: #ffffff !important;border: 1px solid #ffb300;"
                      :disabled="!valid"
                      color="success"
                      class="mt-5"
                      type="submit"
                    >
                      Buy Credits
                    </v-btn>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';

export default {
  name: 'buycredits',
  components: {
    PageHeader
  },
  data: () => ({
    valid: true,
    credits: null,
    rules: {
      required: value => !!value || 'Required.'
    }
  }),
  computed: {
    creditOptions () {
      return [
        {
          id: 1,
          credits: 5,
          value: 5
        },
        {
          id: 2,
          credits: 10,
          value: 10
        },
        {
          id: 3,
          credits: 20,
          value: 20
        }
      ]
    }
  },
  methods: {
     validate () {
      var scope = this;
      var isValid = scope.$refs.form.validate();
      if(isValid){
        scope.overlay = true;
        scope.buyCredits();
      }
    },
    buyCredits () {
      this.$router.push({name: 'payment-stub', query: {amount: this.credits}});
    }
  },
  created () {
    
  }
}
</script>